import React, { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ArticleList from './components/ArticleList';
import ArticleEditor from './components/ArticleEditor';
import { Article } from '../../utils/articleApi';

async function logoutAdmin() {
  try {
    await fetch('/.netlify/functions/admin-auth-logout', {
      method: 'POST',
      credentials: 'include',
    });
  } finally {
    window.location.reload();
  }
}

export default function Admin() {
  const [selectedArticle, setSelectedArticle] = useState<Article | null>(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'robots');
    meta.setAttribute('content', 'noindex, nofollow');
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  const handleEditArticle = (article: Article) => {
    setSelectedArticle(article);
    setIsEditing(true);
  };

  const handleCreateNew = () => {
    setSelectedArticle(null);
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    setSelectedArticle(null);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setSelectedArticle(null);
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-[#111827] mb-2">記事管理</h1>
              <p className="text-[#6B7280]">記事の作成・編集・削除を行えます</p>
            </div>
            <button
              type="button"
              onClick={() => void logoutAdmin()}
              className="self-start sm:self-auto text-sm text-gray-600 hover:text-gray-900 underline"
            >
              ログアウト
            </button>
          </div>

          {isEditing ? (
            <ArticleEditor
              article={selectedArticle}
              onSave={handleSave}
              onCancel={handleCancel}
            />
          ) : (
            <ArticleList
              onEdit={handleEditArticle}
              onCreateNew={handleCreateNew}
            />
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}